import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface IbuttonState {
  isSetPricesButtonShown: boolean;
}

const initialState: IbuttonState = {
  isSetPricesButtonShown: false,
};

export const setPricesButtonSlice = createSlice({
  name: "ButtonSlice",
  initialState,
  reducers: {
    setIsSetPricesButtonShown: (state, action: PayloadAction<boolean>) => {
      state.isSetPricesButtonShown = action.payload;
    },
  },
});

export const { setIsSetPricesButtonShown } = setPricesButtonSlice.actions;
export const setPricesButton = setPricesButtonSlice.reducer;
